import React from 'react'
import { Modal, Button } from 'semantic-ui-react'
import { useCreateLabOrderBusinessLogic } from '../../logic'
import { useHistory } from 'react-router-dom'
import { SETTINGS } from '../../../../config/routes'

export const StripeAccountRequiredModal = () => {
    const { push } = useHistory()
    const businessLogic = useCreateLabOrderBusinessLogic()
    const showStripeAccountRequiredModal = businessLogic?.showStripeAccountRequiredModal ?? false

    const onOkayClick = () => {
        businessLogic?.toggleStripeAccountRequiredModal?.()
        push(SETTINGS.billing)
    }

    return (
        <Modal open={showStripeAccountRequiredModal} size="small">
            <Modal.Header>Billing Information Required</Modal.Header>
            <Modal.Content>
                <p>
                    A valid payment method is required to process payments for this billing type.
                    Please set up your billing information in the Billing Settings via Stripe to continue.
                </p>
            </Modal.Content>
            <Modal.Actions>
                <Button primary onClick={onOkayClick}>
                    Billing Settings
                </Button>
            </Modal.Actions>
        </Modal>
    )
}

